<template>
  <div class="pb-[30px]">
    <template v-for="x in menu" :key="x.key">
      <div v-if="data?.[x.key]?.data?.length" class="mb-[50px]">
        <div class="flex-y-center justify-between">
          <div class="text-[18px] font-bold">{{ x.label }}</div>
          <a
            v-if="data?.[x.key]?.total > x.max"
            class="cursor-pointer text-14 text-font-60 hover:text-primary flex-y-center"
            @click="emits('select', x.key)"
          >
            {{ $t('cha-kan-geng-duo')
            }}<iconpark-icon name="arrowright"></iconpark-icon>
          </a>
        </div>
        <component
          :is="Side['' + x.key]"
          :ref="(el: any) => (pageRef[x.key] = el)"
          class="mt-[30px]"
          :words="words"
          :max="x.max"
          :data="data[x.key]?.data || []"
        />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import Page from './index.tsx'

const { $t } = useNuxtApp()
const emits = defineEmits(['select'])

const pageRef = ref<any>({})

const Side = Page as Record<string, any>

const total = useDicts('site').filter((item) => item.key !== 'all')

const props = defineProps<{
  data: any
  words: string[]
  menu: any
}>()
</script>
